
import MultiPropertyCalendarWrapper from './MultiPropertyCalendar';
import { useProperties } from '@/hooks/useProperties';

const AdminCalendarTab = () => {
  const { data: properties = [], isLoading } = useProperties();

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="text-sm text-gray-500">Cargando propiedades...</div>
      </div>
    );
  }

  if (properties.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No hay propiedades disponibles para mostrar en el calendario.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Calendario de Propiedades</h2>
      </div>
      
      <MultiPropertyCalendarWrapper 
        properties={properties} 
        isAdminContext={true}
      />
    </div>
  );
};

export default AdminCalendarTab;
